// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"56a55242","100":"ea2574a6","145":"06ee7ef7","249":"2bb6055a","280":"c7e44be7","453":"fd2f0c4a","513":"9a731ddb","699":"80155c42"}[chunkId] + ".chunk.js";
};